module.exports = __webpack_public_path__ + "img/2-2.073fbb07.svg";